module.exports = __webpack_public_path__ + "static/media/hardware-banner3.ddc95b66.png";